import { filter } from "lodash";
import { ParticipantDto } from "../models/Participant";
import { axiosInstance } from "./AxiosDefaults";

export const getAllParticipants = (): Promise<any> => {
  // const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  // const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/participants", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const createParticipant = (
  participant: ParticipantDto,
  base64QrCode: string
): Promise<any> => {
  return axiosInstance.post(
    "/participants",
    { participant: participant, base64QrCode: base64QrCode },
    { headers: { "Content-Type": "application/json" } }
  );
};

export const getAllParticipantsInactive = (filters: {
  year?: string;
  participantType?: string;
  company?: string;
  active?: boolean;
  fcmToken?: boolean;
}): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/participants/filters-participant", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
    params: filters,
  });
};

export const getAllMobileParticipants = (): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get("/participants/mobile-app", {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getAllCompanyParticipants = (): Promise<any> => {
  return axiosInstance.get("/participants-company", {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const getParticipant = (id: string): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;

  return axiosInstance.get(`${`/participants`}/${id}`, {
    withCredentials: false,
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const getParticipantCompany = (id: string): Promise<any> => {
  return axiosInstance.get(`${`/participants-company`}/${id}`, {
    withCredentials: false,
    headers: { "Content-Type": "application/json" },
  });
};

export const sendAgainQR = async (
  participantId: string | any,
  base64QrCode: string | any
): Promise<any> => {
  return axiosInstance.put(
    `/participants/send-qr/${participantId}`,
    { base64QrCode: base64QrCode },
    { headers: { "Content-Type": "application/json" } }
  );
};

export const createParticipantCompany = (participant: any): Promise<any> => {
  return axiosInstance.post("/participants-company", participant, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateParticipant = async (
  id: string,
  participant: ParticipantDto
): Promise<any> => {
  const secretId = process.env.REACT_APP_SECRET_ID_HEADER;
  const clientId = process.env.REACT_APP_CLIENT_ID_ADMINISTRATION;
  return axiosInstance.put(`${"/participants"}/${id}`, participant, {
    headers: {
      "Content-Type": "application/json",
      "x-secretid": secretId,
      "x-clientid": clientId,
    },
  });
};

export const updateOneParticipantWithRoomKind = async (
  id: string,
  kindRoomId: string
): Promise<any> => {
  return axiosInstance.put(`${"/participants/kindRoom"}/${id}/${kindRoomId}`, {
    headers: { "Content-Type": "application/json" },
  });
};

export const updateCompanyParticipant = async (
  id: string,
  participant: any
): Promise<any> => {
  return axiosInstance.put(`${"/participants-company"}/${id}`, participant, {
    headers: { "Content-Type": "application/json" },
  });
};

export const deleteParticipant = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/participants"}/${id}`);
};

export const deleteCompanyParticipant = (id: string): Promise<any> => {
  return axiosInstance.delete(`${"/participants-company"}/${id}`);
};
